import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(27, 27, 27, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  width: 720px;
  max-height: 90vh;
  overflow-y: auto;
  background: #FFFFFF;
  border-radius: 8px;
  position: relative;
  padding: 56px 32px 40px;

  @media (max-width: 768px) {
    width: 90%;
    padding: 48px 24px 32px;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 40px 16px 24px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 24px;
  background: none;
  border: none;
  font-size: 32px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: #636363;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  &:hover {
    color: #3D3D3D;
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 24px;
  left: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 16px;
  color: #3D3D3D;


  span {
    font-family: 'Mangueira', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    color: #3D3D3D;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const CalendarIcon = styled.div`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: #EEF0FD;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;

`;

export const ModalTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1em;
  text-align: center;
  color: #3D3D3D;
  margin: 0 0 16px;
`;

export const ModalDescription = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.54em;
  text-align: center;
  color: #636363;
  margin: 0 0 32px;
`;

export const VisitInfoCard = styled.div`
  background: #F0F0F0;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ConsultantSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > span:first-child {
    font-size: 24px;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;

    > span {
      font-family: 'Mangueira', sans-serif;
      font-weight: 500;
      font-size: 14px;
      color: #636363;
    }

    > strong {
      font-family: 'Mangueira', sans-serif;
      font-weight: 700;
      font-size: 16px;
      color: #636363;
    }
  }
`;

export const DateSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > span:first-child {
    font-size: 24px;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 4px;

    > span {
      font-family: 'Mangueira', sans-serif;
      font-weight: 500;
      font-size: 14px;
      color: #636363;
    }

    > strong {
      font-family: 'Mangueira', sans-serif;
      font-weight: 700;
      font-size: 16px;
      color: #636363;
    }
  }
`;

export const SummarySection = styled.div`
  margin-bottom: 24px;
`;

export const SummaryTitle = styled.h3`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.54em;
  color: #3D3D3D;
  margin: 0 0 16px;
`;

export const SummaryText = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.54em;
  color: #636363;
  margin: 0;
  padding: 16px;
  background: #F9F9F9;
  border-radius: 8px;
`;

export const ActionPlansSection = styled.div`
  margin-bottom: 48px;
  overflow: visible;
`;

export const ConsultantPlan = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background: #F9F9F9;
  border-radius: 8px;
`;

export const ResellerPlan = styled.div`
  padding: 16px;
  background: #F9F9F9;
  border-radius: 8px;
`;

export const PlanTitle = styled.h4`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 1.54em;
  color: #3D3D3D;
  margin: 0 0 8px;
`;

export const AttentionTitle = styled.h4`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.54em;
  color: #3D3D3D;
  margin: 32px 0 16px;
  text-align: center;
  word-wrap: break-word;

  @media (max-width: 480px) {
    font-size: 14px;
    margin: 24px 0 12px;
  }
`;

export const PlanText = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.54em;
  color: #636363;
  margin: 0;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 18px;
`;

export const CancelButton = styled.button`
  flex: 1;
  padding: 13px 45px;
  background: #FFFFFF;
  border: 1px solid #3D3D3D;
  border-radius: 5.33px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.54em;
  color: #3D3D3D;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #F5F5F5;
  }
`;

export const ActionButton = styled.button`
  flex: 1;
  padding: 13px 45px;
  background: #0B29FB;
  border: none;
  border-radius: 5.33px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.54em;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0922E8;
  }
`;

export const SkeletonContainer = styled.div`
  width: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
`;

export const SkeletonHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 16px;
`;

export const SkeletonHeaderTitle = styled.div`
  width: 250px;
  height: 32px;
  background: #eee;
  border-radius: 4px;
  margin: 0 auto;
`;

export const SkeletonHeaderBadge = styled.div`
  width: 100%;
  height: 160px;
  background: #f0f0f0;
  border-radius: 8px;
`;

export const SkeletonLineLarge = styled.div`
  width: 100%;
  height: 20px;
  background: #eee;
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const SkeletonLine = styled.div`
  width: 100%;
  height: 16px;
  background: #f2f2f2;
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const SkeletonLineShort = styled.div`
  width: 100%;
  height: 16px;
  background: #f2f2f2;
  border-radius: 4px;
  margin-bottom: 48px;
`;

export const SkeletonButtons = styled.div`
  display: flex;
  gap: 20px;
  margin-top: auto;
`;

export const SkeletonButton = styled.div`
  flex: 1;
  height: 52px;
  background: #eee;
  border-radius: 8px;
`;

export const LegalText = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.4em;
  color: #636363;
  margin: 16px 0;
  padding: 12px;
  background: #FAFAFA;
  border-radius: 6px;
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #0B29FB;
  cursor: pointer;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Mangueira', sans-serif;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;
